import React, { useEffect,useState } from "react";
import { useAuth } from "component/UseAuth";
import { showConfirm, showSuccess, showError } from "component/utils/SweetAlert";
import axios from "axios";
import { pdf  } from "@react-pdf/renderer";

import Sidebar from "component/Sidebar";
import Navbar from "component/Navbar";


import BulanTanggal from "component/akunting/report/neraca/BulanTanggal";
import MyReportneracadtlmon from "component/utils/MyReportneracadtlmon";
import MyReportneracadtlday from "component/utils/MyReportneracadtlday";

function NeracaDetail() {
    const { user } = useAuth();
    const [loadingCoA, setLoadingCoA] = useState(false);

  useEffect(() => {
      document.title = "Green Hill Kemuning | Neraca Detail";
      window.scrollTo(0, 0);
  }, []);

    const handleDownloadAll = async ({ mode, selectedDate }) => {
    try {
      setLoadingCoA(true);
      const reg_desc = user?.company;
      const dateObj = new Date(selectedDate);
      const formattedDate = `${String(dateObj.getDate()).padStart(2, "0")}-${String(dateObj.getMonth() + 1).padStart(2, "0")}-${dateObj.getFullYear()}`;

      if (mode === "day") {
        const res = await axios.post(
          `${process.env.REACT_APP_API}/neracadtlbyday`,
          { reg_desc, tanggal:formattedDate }
        );
        const jsonData = res.data.data;
        const blob = await pdf(
          <MyReportneracadtlday data={jsonData} tanggal={formattedDate} userBy={user?.name || "Admin"} />
        ).toBlob();

        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "laporan-detail-neracaday.pdf";
        a.click();
        URL.revokeObjectURL(url);
      } else {
        const res = await axios.post(
          `${process.env.REACT_APP_API}/neracadtlbymonth`,
          { reg_desc, tanggal:formattedDate }
        );
        const jsonData = res.data.data;
        const blob = await pdf(
          <MyReportneracadtlmon data={jsonData} tanggal={formattedDate} userBy={user?.name || "Admin"} />
        ).toBlob();

        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "laporan-detail-neracamonth.pdf";
        a.click();
        URL.revokeObjectURL(url);
      }

    } catch (err) {
      console.error("Gagal mengambil data Neraca:", err);
      showError("Gagal mengambil data Neraca Semua.");
    } finally {
      setLoadingCoA(false);
    }
  };
      
  return (
    <div class="layout-wrapper layout-content-navbar">
      <div class="layout-container">
        <Sidebar />

        <div class="layout-page" style={{ backgroundColor: "#f8f9fa" }}>
            <Navbar />
            <div class="content-wrapper">
                <div class="container-xxl flex-grow-1 container-p-y">
                  <div class="row px-4">
                      <div class="card shadow p-3">
                        <div class="card-body">
                          <div class="row">
                            <div className="d-flex justify-content-between align-items-center">
                              <h5 className="card-title m-0">Neraca Detail Management</h5>
                            </div>
                          </div>
                        </div>  
                        <BulanTanggal
                          onDownload={(formData) => handleDownloadAll(formData)}
                          onLoading={loadingCoA}
                          title="Download Detail Neraca by Day/Month"
                        />
                      </div>
                  </div>
                </div>
            </div>
        </div>
      </div>
      <div class="layout-overlay layout-menu-toggle"></div>    
    </div>
  );
}

export default NeracaDetail;
